import { Color } from '@kite-js/theme-types';

const red: Color = {
    // Remove this block when do SKYWL-471
    // ------------------------------
    100: '#f9d8d8',
    200: '#e86161',
    400: '#b42424',
    // ------------------------------

    50: '#FBEBEB',
    300: '#CC0000',
    500: '#800800',
};

export default red;
